// Shared helpers for the attendance pages.

export const STATUS_BADGES = {
  not_started: { label: 'Not open yet', className: 'badge-info' },
  open: { label: 'Open', className: 'badge-success' },
  closed: { label: 'Closed', className: 'badge-secondary' }
};

export const TRAINING_BADGES = {
  open: { label: 'Day open now', className: 'badge-success' },
  ongoing: { label: 'Ongoing', className: 'badge-info' },
  upcoming: { label: 'Upcoming', className: 'badge-warning' },
  completed: { label: 'Completed', className: 'badge-secondary' }
};

const pad = (n) => String(n).padStart(2, '0');

// Date -> "YYYY-MM-DD" in local time, for <input type="date">.
export const toDateInput = (value) => {
  const d = new Date(value);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// "HH:MM" in local time, for <input type="time">.
export const toTimeInput = (value) => {
  const d = new Date(value);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;

// The day after `date` (a "YYYY-MM-DD" string), skipping Saturday and Sunday if asked.
export const nextDate = (date, skipWeekends) => {
  const d = new Date(`${date}T12:00`);
  do { d.setDate(d.getDate() + 1); } while (skipWeekends && isWeekend(d));
  return toDateInput(d);
};

// Day 1..N on consecutive dates from `firstDate`, each with the same scan window.
export const buildDays = ({ count, firstDate, startTime, endTime, skipWeekends, firstNumber = 1 }) => {
  const days = [];
  let date = firstDate;
  for (let i = 0; i < count; i++) {
    if (i > 0) date = nextDate(date, skipWeekends);
    days.push({
      title: `Day ${firstNumber + i}`,
      date,
      starts_at: new Date(`${date}T${startTime}`).toISOString(),
      ends_at: new Date(`${date}T${endTime}`).toISOString()
    });
  }
  return days;
};

export const formatDay = (value) =>
  new Date(value).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });

// Date -> value for an <input type="datetime-local">, in local time.
export const toDateTimeLocal = (value) => {
  const d = new Date(value);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const formatTime = (value) =>
  new Date(value).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

export const formatWindow = (start, end) => {
  const s = new Date(start);
  const e = new Date(end);
  const day = s.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const sameDay = s.toDateString() === e.toDateString();
  return sameDay
    ? `${day}, ${formatTime(s)}–${formatTime(e)}`
    : `${day} ${formatTime(s)} – ${e.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })} ${formatTime(e)}`;
};
